import { render } from "./SessionDetailsV2.vue?vue&type=template&id=11767bf5&scoped=true"
import script from "./SessionDetailsV2.vue?vue&type=script&lang=js"
export * from "./SessionDetailsV2.vue?vue&type=script&lang=js"

import "./SessionDetailsV2.vue?vue&type=style&index=0&id=11767bf5&lang=css"
import "./SessionDetailsV2.vue?vue&type=style&index=1&id=11767bf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11767bf5"]])

export default __exports__